import { fluidProp, whenProp } from 'remote-com-shared/style/helpers';
import { breakpointUntil } from 'remote-com-shared/style/mediaQueries';
import { sharedTransition } from 'remote-com-shared/style/motion';
import styled, { css } from 'styled-components';

import { fromBreakpointReference, sharedShadowUp, untilBreakpointReference } from './shared';

export const Navigation = styled.nav`
  flex-grow: 1;

  ${untilBreakpointReference(css`
    ${sharedTransition('transform')}

    --topOffset: calc(36px + calc(var(--panelYSpace) * 2)); // Height of Brand

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    transform: translateY(-100%);
    padding-top: var(--topOffset);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: inherit;
    overflow: hidden;

    ${whenProp(
      '$isOpen',
      css`
        transform: translateY(0);
      `
    )}
  `)}

  ${fromBreakpointReference(css`
    display: flex;
    justify-content: flex-end;
  `)}

  ${untilBreakpointReference(css`
    flex-direction: column-reverse;
  `)}
`;

const NavigationArea = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
`;

export const NavigationPrimary = styled(NavigationArea)`
  ${untilBreakpointReference(css`
    flex-grow: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    flex-direction: column;
    padding-bottom: var(--panelYSpace);
  `)}
`;

export const NavigationSecondary = styled(NavigationArea).attrs((props) => ({
  ...props,
  as: 'div',
}))`
  align-items: center;
  color: #fff;
  box-sizing: border-box;

  li > a {
    width: 142px;
    height: 40px;
    justify-content: center;
  }

  * + * {
    margin-left: 24px;

    ${breakpointUntil.sm(css`
      margin-left: 10px;
    `)}
  }

  ${untilBreakpointReference(css`
    padding: var(--panelYSpace) var(--panelXSpace);
    box-shadow: ${sharedShadowUp};
    justify-content: flex-start;
  `)}

  ${fromBreakpointReference(css`
    ${fluidProp('margin-left', '16px', '38px')}
  `)}
`;
